/*
 * File: MainRedirect.jsx
 * Project: frontend
 * File Created: Monday, 1st May 2023 5:07:21 pm
 * Author: Sharath Puranik (sharath.puranik@stylumia.com)
 * -----
 * Last Modified: Thursday, 29th August 2024 11:41:07 pm
 * Modified By: Sharath Puranik (sharath.puranik@stylumia.com>)
 * -----
 * Copyright - 2024, Stylumia Intelligence Technology Pvt Ltd
 */

import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { redirectMain } from "../../constants/constants";

function MainRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const search = location.search;
  const redirect = new URLSearchParams(search).get("redirect");

  useEffect(() => {
    const search = location.search;
    const redirect = new URLSearchParams(search).get("redirect");

    if (redirect) {
      navigate(`/login/magic?redirect=${redirect}`);
    } else {
      navigate(`/login/magic?redirect=${redirectMain}`);
    }
  }, [redirect, navigate]);

  return <></>;
}

export default MainRedirect;
